@if (registered) {
  <h1 mat-dialog-title>{{ 'signup.doneTitle' | t }}</h1>
  <div mat-dialog-content>
    <p>{{ 'signup.doneText' | t: { email: emailFormControl.value } }}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancelClick()" cdkFocusInitial>{{ 'common.close' | t }}</button>
  </div>
} @else {
  <h1 mat-dialog-title>{{ 'signup.title' | t }}</h1>
  <form [formGroup]="signupForm" (ngSubmit)="onRegisterLocal()">
    <div mat-dialog-content>
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signup.emailLabel' | t }}</mat-label>
        <input matInput type="email" [formControl]="emailFormControl">
        @if (emailFormControl.hasError('required')) {
          <mat-error>{{ 'signin.emailRequired' | t }}</mat-error>
        }
        @if (emailFormControl.hasError('email')) {
          <mat-error>{{ 'signin.emailInvalid' | t }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signup.username' | t }}</mat-label>
        <input matInput [formControl]="usernameFormControl">
        @if (usernameFormControl.hasError('required')) {
          <mat-error>{{ 'signup.usernameRequired' | t }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signup.firstName' | t }}</mat-label>
        <input matInput [formControl]="nameFormControl">
        @if (nameFormControl.hasError('required')) {
          <mat-error>{{ 'signup.firstNameRequired' | t }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signup.lastName' | t }}</mat-label>
        <input matInput [formControl]="surnameFormControl">
        @if (surnameFormControl.hasError('required')) {
          <mat-error>{{ 'signup.lastNameRequired' | t }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signup.password' | t }}</mat-label>
        <input matInput type="password" [formControl]="passwordFormControl">
        @if (passwordFormControl.hasError('minlength')) {
          <mat-error>{{ 'signup.passwordShort' | t }}</mat-error>
        }
        @if (passwordFormControl.hasError('required')) {
          <mat-error>{{ 'signin.passwordRequired' | t }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="input">
        <mat-label>{{ 'signup.passwordRepeat' | t }}</mat-label>
        <input matInput type="password" [formControl]="passwordRepeatFormControl">
      </mat-form-field>
      @if (signupForm.hasError('passwordMismatch') && passwordRepeatFormControl.value) {
        <p class="form-error">{{ 'signup.passwordMismatch' | t }}</p>
      }

      <div class="consents">
        <mat-checkbox [formControl]="termsFormControl">
          {{ 'signup.acceptTerms' | t }} <a routerLink="/terms" target="_blank" rel="noopener">{{ 'signup.termsLink' | t }}</a>
        </mat-checkbox>
        <mat-checkbox [formControl]="privacyFormControl">
          {{ 'signup.readPrivacy' | t }} <a routerLink="/privacy" target="_blank" rel="noopener">{{ 'signup.privacyLink' | t }}</a>
        </mat-checkbox>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button type="button" (click)="onCancelClick()">{{ 'common.cancel' | t }}</button>
      <button mat-button type="submit" [disabled]="signupForm.invalid || submitting" cdkFocusInitial>
        {{ 'signup.submit' | t }}
      </button>
      @if (facebookAvailable) {
        <button mat-raised-button color="primary" type="button" [disabled]="!consentsGiven"
          (click)="onAuthenticateFacebook()">
          {{ 'signup.facebook' | t }}
        </button>
      }
    </div>
  </form>
}
